/* IOE Labs — animaciones de scroll estilo producto. Sin dependencias. */
(() => {
  'use strict';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const progressOf = el => {
    const r = el.getBoundingClientRect();
    const total = r.height - window.innerHeight;
    return total > 0 ? clamp(-r.top / total) : (r.top < 0 ? 1 : 0);
  };
  function setup() {
    const heroes = [...document.querySelectorAll('[data-ioe-hero]')];
    const seqs = [...document.querySelectorAll('[data-ioe-seq]')];
    const pures = [...document.querySelectorAll('[data-ioe-pure]')];
    const bar = document.querySelector('[data-ioe-bar]');
    const buy = document.querySelector('[data-ioe-buy]');
    heroes.forEach(h => requestAnimationFrame(() => setTimeout(() => h.classList.remove('is-loading'), 60)));
    if (reduce) { pures.forEach(p => { p.querySelectorAll('li').forEach(li => li.classList.add('is-struck')); p.querySelector('[data-ioe-answer]')?.classList.add('is-on'); }); seqs.forEach(s => s.querySelectorAll('.ioe-seq__frame').forEach(f => f.classList.add('is-on'))); }
    let ticking = false;
    const update = () => {
      ticking = false;
      if (!reduce) {
        heroes.forEach(h => h.style.setProperty('--p', progressOf(h).toFixed(4)));
        seqs.forEach(s => {
          const p = progressOf(s), frames = [...s.querySelectorAll('.ioe-seq__frame')];
          s.style.setProperty('--p', p.toFixed(4));
          const i = Math.min(frames.length - 1, Math.floor(p * frames.length * 0.999));
          frames.forEach((f, k) => { f.classList.toggle('is-on', k === i); f.classList.toggle('is-past', k < i); });
        });
        pures.forEach(pu => {
          const items = [...pu.querySelectorAll('li')];
          const r = pu.getBoundingClientRect(), vh = window.innerHeight;
          const p = clamp((vh * 0.85 - r.top) / (r.height * 0.8));
          items.forEach((li, k) => li.classList.toggle('is-struck', p > (k + 1) / (items.length + 2)));
          pu.querySelector('[data-ioe-answer]')?.classList.toggle('is-on', p > (items.length + 1) / (items.length + 2));
        });
      }
      if (bar) {
        const past = heroes[0] ? heroes[0].getBoundingClientRect().bottom < window.innerHeight * 0.6 : window.scrollY > 600;
        const atBuy = buy ? (() => { const r = buy.getBoundingClientRect(); return r.top < window.innerHeight && r.bottom > 0; })() : false;
        bar.classList.toggle('is-on', past && !atBuy);
      }
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
    document.querySelectorAll('[data-ioe-qty]').forEach(q => {
      const input = q.querySelector('input');
      q.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
        const step = Number(input.step) || 1, min = Number(input.min) || 1;
        input.value = Math.max(min, (Number(input.value) || min) + Number(b.dataset.step) * step);
      }));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();
